module.exports = __webpack_public_path__ + "static/media/Bubble_Tea_tapioca_pearl-01-512.b565487d.png";